<style lang="scss" src='./ProvisioningStep6.scss' scoped ></style>
<template src="./ProvisioningStep6.html"></template>

<script>
import { mapState, mapMutations } from 'vuex';
import { MoveToInventory } from '@/api/api';

export default {
  name: 'ProvisioningStep6',
  data() {
    return ({
      intitalTimer: 120,
      sensor: null,
      timer: 0,
      clockCall: null,
      loading: false,
      attemps: 0,
      can_continue: false,
    });
  },
  computed: {
    ...mapState('SensorProvisioning', {
      provisionPayload: (state) => state.provisionPayload,
    }),
    
    showWarning(){
      const showWarning = this.checkIfNeedsWarning();
      if(!showWarning){
        this.$bvModal.hide('md-gps-timeout');
      }
      return showWarning;
    },

    showGPSSpinner(){
      if(this.provisionPayload && this.sensor){
        if ((!this.sensor.latitude || !this.sensor.longitude) && this.provisionPayload.sensor_depth > 0 && !this.can_continue) {
          return true;
        }
      }
      return false;
    },

    showGPSSpinnerContinue(){
      if(this.provisionPayload && this.sensor){
        if ((!this.sensor.latitude || !this.sensor.longitude) && this.provisionPayload.sensor_depth > 0 && this.can_continue) {
          return true;
        }
      }
      return false;
    },

    showGPSCheck(){
      if(this.sensor){
        if((this.sensor.latitude && this.sensor.longitude)){
          return true;
        }
      }
      return false;
    },

    showTimer() {
      let mins = parseInt(this.timer / 60);
      let secs = this.timer % 60;
      return (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
    }

  },

  methods: {
    ...mapMutations('SensorProvisioning', ['setCanBack', 'setCanContinue']),
    ...mapMutations('SensorList', ['updateSensor']),

    checkIfNeedsWarning() {
      if(this.provisionPayload && this.sensor){
        if(this.provisionPayload.sensor_depth > 0 && (this.sensor.latitude == null || this.sensor.longitude == null) && !this.can_continue){
          return true;
        }
      }
      return false;
    },

    startTimer() {
      this.timer = this.intitalTimer;
      this.clockCall = setInterval(() => {
          this.decrementClock();
      }, 1000);
    },

    decrementClock() {
      if(this.timer === 0){
          clearInterval(this.clockCall);
          if(this.attemps < 2){
            this.$bvModal.show('md-gps-timeout');
          }else{
            this.can_continue = true;
            this.$emit('step6Continue');
          }
      }else{
          this.timer -= 1;
      }
    },

    tryAgain() {
      this.$bvModal.hide('md-gps-timeout');
      this.attemps += 1;
      this.startTimer();
    },
    
    async moveToInventory() {
      this.loading = true;
      await MoveToInventory(this.sensor.sensor_id).then( resetSensor => {
        this.$bvModal.hide('md-gps-tomeout');
        this.updateSensor(resetSensor);
        this.$router.go(-1);
      }).finally(() => {
        this.loading = false;
      });
    },

  },

  beforeCreate() {},

  created() {},

  activated() {
    this.setCanContinue(null);
    this.setCanBack(null);
    if(this.checkIfNeedsWarning()){
      this.startTimer();
    }
  },

  deactivated() {
    if(this.clockCall){
      clearInterval(this.clockCall);
    }
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
  },

  unmounted() {
    if(this.clockCall){
      clearInterval(this.clockCall);
    }
  },

};
</script>
